export const purchaseOrderSendDefaultMessage = `Dear supplier,

Please find attached a new PO.
Could you please check and confirm the delivery date

If there is no problem, please send me back PO signed together with your PI within the next few days.

Best regards,
Miliboo buying team.

***this is an automatic email from our system, please contact the people you are used to deal with***

----

Bonjour,

Vous trouverez ci-joint une nouvelle commande.
Je vous remercie de bien vouloir confirmer une date de livraison pour chaque article et d'indiquer le numéro de référence MILIBOO sur votre confirmation de commande.

Aucune confirmation de commande ne pourra être enregistrée sans ce numéro

Cordialement,
Service Achat Miliboo.

***Ce message est envoyé automatiquement depuis notre système, merci de contacter les personnes habituellement en charge de vos dossiers***`;

export function getUnsignedProformaWaitingForSupplierAgreementDefaultMessage(
  supplierName?: string | null,
  supplierPortalLink?: string | null,
): string {
  return `Dear ${supplierName?.trim() || 'Supplier'},

In accordance with the EU Deforestation Regulation (EUDR), you are required to complete and submit an EUDR Due Diligence Statement via our EUDR Information and Evidence portal for this PO.

Please complete this action within 5 working days of receiving this email.

Please note:
Please complete and submit the EUDR Due Diligence Statement as instructed in the portal.
${supplierPortalLink?.trim() ? `Portal link: ${supplierPortalLink.trim()}\n` : ''}Mass production may only start after the EUDR Due Diligence Statement has been reviewed and approved by Miliboo.
Any delay in submission may result in a delay to production.

Once your statement is submitted, our team will review it and notify you of the result. If you have any questions or need assistance, please contact us at qualite@miliboo.com.

Thank you for your cooperation and support.

Kind regards,
Miliboo Quality Team`;
}

export function getSignedProformaSendDefaultMessage(
  isConcernedByProductionDeclaration: boolean,
): string {
  return `Dear Supplier,

Thank you for your confirmation.
Please find attached the signed PI for our order.
${isConcernedByProductionDeclaration ? '\nWe hereby confirm our approval of the preliminary EUDR Due Diligence Statement provided.\n' : ''}
You can proceed with the order.

Best regards,
Miliboo buying team.`;
}
